<!--   


<div class="container-scroller">
    <app-top-bar>

    </app-top-bar>
<div class="container-fluid page-body-wrapper">


             <app-right-sidebar>

              </app-right-sidebar>
             <app-sidemenus>

            </app-sidemenus>
           <app-view-contract></app-view-contract>>
 
</div>
</div> -->

<app-view-contract></app-view-contract>